import { MoovyButton, MoovyCard, UserRoleIcon } from '../../components'

import LogoutRounded from '@mui/icons-material/LogoutRounded'
import Box from '@mui/material/Box'
import { FormattedMessage } from 'react-intl'
import useAuth from '../../hooks/useAuth'

const UserDetails = () => {
  const { isAdmin, userFullName, usernameForAvatar, logout } = useAuth()
  const userRoleText = isAdmin ? (
    <FormattedMessage id="menu.user.tooltip.admin" />
  ) : (
    <FormattedMessage id="menu.user.tooltip.user" />
  )
  return (
    <>
      <h1>
        <FormattedMessage id="page.userDetails.title" />
      </h1>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        marginTop="3rem"
        marginBottom="3rem"
        padding="1rem"
        gap="3rem"
      >
        <Box
          sx={{
            width: {
              xs: '100%',
              sm: 'auto',
            },
          }}
        >
          <MoovyCard
            key="user-details-card"
            avatarName={usernameForAvatar}
            cardTitle={userFullName}
            cardSecondaryTitle={
              <Box display="flex" columnGap="0.5rem" alignItems="center">
                <UserRoleIcon />
                {userRoleText}
              </Box>
            }
            cardContentList={[]}
          />
        </Box>
        <MoovyButton onClick={logout}>
          <Box display="flex" gap="0.5rem">
            <LogoutRounded />
            <FormattedMessage id="menu.user.logout" />
          </Box>
        </MoovyButton>
      </Box>
    </>
  )
}

export default UserDetails
